"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactDetails = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const look_up_entity_1 = require("./look-up.entity");
const child_details_entity_1 = require("./child-details.entity");
const contact_entity_1 = require("./contact.entity");
let ContactDetails = class ContactDetails {
    constructor(createdAt, updatedAt, createdBy, updatedBy, contact, childDetails) {
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.contact = contact;
        this.childDetails = childDetails;
    }
};
exports.ContactDetails = ContactDetails;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Object)
], ContactDetails.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "gender", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], ContactDetails.prototype, "gender", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "date_of_birth", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], ContactDetails.prototype, "dateOfBirth", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "favourite_food",
        type: "varchar",
        length: 100,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], ContactDetails.prototype, "favouriteFood", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "favourite_restaurant",
        type: "varchar",
        length: 100,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], ContactDetails.prototype, "favouriteRestaurant", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "personal_history", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], ContactDetails.prototype, "personalHistory", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "major_achievements", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], ContactDetails.prototype, "majorAchievements", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "marital_status", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], ContactDetails.prototype, "maritalStatus", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "date_of_wedding", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], ContactDetails.prototype, "dateOfWedding", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "spouse_name", type: "varchar", length: 100, nullable: true }),
    tslib_1.__metadata("design:type", String)
], ContactDetails.prototype, "spouseName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "spouse_date_of_birth", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], ContactDetails.prototype, "spouseDateOfBirth", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "spouse_working_status", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], ContactDetails.prototype, "spouseWorkingStatus", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "working_company",
        type: "varchar",
        length: 100,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], ContactDetails.prototype, "workingCompany", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], ContactDetails.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_g = typeof Date !== "undefined" && Date) === "function" ? _g : Object)
], ContactDetails.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_h = typeof Date !== "undefined" && Date) === "function" ? _h : Object)
], ContactDetails.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], ContactDetails.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], ContactDetails.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "gender", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_j = typeof look_up_entity_1.LookUp !== "undefined" && look_up_entity_1.LookUp) === "function" ? _j : Object)
], ContactDetails.prototype, "genderType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "spouse_working_status", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_k = typeof look_up_entity_1.LookUp !== "undefined" && look_up_entity_1.LookUp) === "function" ? _k : Object)
], ContactDetails.prototype, "spouseWorkingStatusType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "marital_status", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_l = typeof look_up_entity_1.LookUp !== "undefined" && look_up_entity_1.LookUp) === "function" ? _l : Object)
], ContactDetails.prototype, "maritalStatusType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => contact_entity_1.Contact, (contact) => contact.contactDetails, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", Object)
], ContactDetails.prototype, "contact", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => child_details_entity_1.ChildDetails, (childDetails) => childDetails.contactDetails, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Object)
], ContactDetails.prototype, "childDetails", void 0);
exports.ContactDetails = ContactDetails = tslib_1.__decorate([
    (0, typeorm_1.Entity)("contact_details"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object, Number, Number, Object, Object])
], ContactDetails);
